<script>
    import I18n from '@js/modules/translations';

    // available: the base condition holds (e.g. hiking) so the tool is shown as a capability.
    // enabled: a route exists, so it can actually run — otherwise it's shown disabled with a hint.
    // onManualMode: arm the on-map waypoint mode so the user can place each stage stop by hand.
    const {onGenerate, onManualMode, available = false, enabled = false} = $props();

    let mode = $state('distance');
    // Writable derived: sensible default per mode (km vs hours), still user-editable until mode flips.
    let target = $derived(mode === 'distance' ? 20 : 6);

    const _distanceUnit = (typeof window !== 'undefined' && window.unit === 'mi') ? 'mi' : 'km';

    const _generate = () => {
        if (!enabled) {
            return;
        }

        onGenerate(mode, Number(target) || 0);
    };
</script>

{#if available}
    <div class="map-multi-day" class:map-tool-disabled={!enabled}>
        <h3 class="map-multi-day-title">
            {I18n.t('js.maps.multi_day.title')}
        </h3>

        <p class="map-multi-day-explain">
            {I18n.t('js.maps.multi_day.explain')}
        </p>

        <div class="map-multi-day-controls">
            <label class="map-multi-day-mode">
                <input type="radio" bind:group={mode} value="distance" disabled={!enabled}/>
                {I18n.t('js.maps.multi_day.by_distance')}
            </label>
            <label class="map-multi-day-mode">
                <input type="radio" bind:group={mode} value="duration" disabled={!enabled}/>
                {I18n.t('js.maps.multi_day.by_duration')}
            </label>

            <input class="map-multi-day-target"
                   type="number"
                   min="1"
                   max={mode === 'distance' ? 999 : 99}
                   disabled={!enabled}
                   aria-label={mode === 'distance' ? `${I18n.t('js.maps.multi_day.by_distance')} (${_distanceUnit})` : `${I18n.t('js.maps.multi_day.by_duration')} (${I18n.t('js.maps.multi_day.unit_h')})`}
                   bind:value={target}/>
            <span class="map-multi-day-unit">
                {mode === 'distance' ? _distanceUnit : I18n.t('js.maps.multi_day.unit_h')}
            </span>

            <button type="button"
                    class="map-multi-day-generate"
                    disabled={!enabled}
                    onclick={_generate}>
                {I18n.t('js.maps.multi_day.generate')}
            </button>
        </div>

        <button type="button"
                class="map-multi-day-manual"
                disabled={!enabled}
                onclick={() => onManualMode?.()}>
            {I18n.t('js.maps.multi_day.manual')}
        </button>

        <p class="map-multi-day-hint">
            {enabled ? I18n.t('js.maps.multi_day.hint') : I18n.t('js.maps.multi_day.needs_route')}
        </p>
    </div>
{/if}
